import { render, staticRenderFns } from "./redboxceshi.vue?vue&type=template&id=01b4dad9&"
import script from "./redboxceshi.vue?vue&type=script&lang=js&"
export * from "./redboxceshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports